import { render } from "./ExportXLSXFile.vue?vue&type=template&id=604f680d&ts=true"
import script from "./ExportXLSXFile.vue?vue&type=script&lang=ts"
export * from "./ExportXLSXFile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adroneleh/projects/vue-js-matrix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__